<script lang="ts">
	import { defineComponent } from "vue";
	import BannerCampus from "../components/landing/BannerCampusSlider.vue";
    import FormarBloqueLanding from "../components/landing/FormarBloqueLanding.vue";
    import Oferta from "../components/landing/Oferta.vue";
    import Ubicacion from "../components/landing/Ubicacion.vue";
import Instalaciones from "../components/landing/Instalaciones.vue";
    import Tour360 from "../components/landing/Tour360.vue";
	// import ModelosEducativos from "../components/landing/ModelosEducativos.vue";
	// import OfertaEducativa from "../components/landing/OfertaEducativa.vue";
	// import HumanitasMuchoMas from "@/components/HumanitasMuchoMas.vue";


	export default defineComponent({
		name: "CampusPresaMadin",
		components: {
			BannerCampus,
            FormarBloqueLanding,
            Oferta,
            Ubicacion,
            Instalaciones,
            Tour360,
		},
		props: {
			campus: {
				type: String,
				required: true,
			},
			banner: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
                currentImage: 0,
                currentImage2: 0,
                images: [
                    '/pagesImages/instalaciones-tijuana-1.webp',
                    '/pagesImages/instalaciones-tijuana-2.webp',
                    '/pagesImages/instalaciones-tijuana-3.webp',
                ],
                images2: [
                    '/pagesImages/instalaciones-tijuana-7.webp',
                    '/pagesImages/instalaciones-tijuana-4.webp',
                    '/pagesImages/instalaciones-tijuana-5.webp',
                ],
                imagesArray: [
                    "/pagesImages/encabezado-landing-Tijuana-B.webp",
                ],
                altArray: [
                    "Universidad Humanitas Campus MAgno Tijuana",
                ],
                tour: [
                    { src:"/pagesImages/tour-Tijuana-1.webp", title:"Tour Virtual Campus Magno Tijuana"},
                    { src:"/pagesImages/tour-Tijuana-2.webp", title:"Tour Virtual Campus Magno Tijuana"},
                ],
                campusName: "TIJUANA",
                campusType: "CAMPUS MAGNO",
                localidad: "Baja California",
                frase: "El único bien es el conocimiento y el único mal es la ignorancia",
                autor: "Sócrates",
            }
        },
        methods: {
            nextImage() {
                this.currentImage = (this.currentImage + 1) % this.images.length
            },
            nextImage2() {
                this.currentImage2 = (this.currentImage2 + 1) % this.images2.length
            }
        }
	});
</script>

<template>
	<!-- <BannerCampus :banner="banner"/> -->
    <BannerCampus :campusType="campusType" :campus="campusName" :localidad="localidad" :slider="imagesArray" :alt="altArray" :frase="frase" :autor="autor" :banner="banner"/>
    <FormarBloqueLanding :frase="'Campus Magno Tijuana'" :testo1="'Está ubicado en una de las zonas con mayor dinamismo del noroeste de México. Aquí, la formación profesional va de la mano con valores humanos, pensamiento crítico y un enfoque ético que trasciende las aulas. En ese sentido, se consolida como una institución de prestigio, reconocida por su modelo educativo centrado en el desarrollo integral del estudiante.'" :testo2="'Campus Magno Tijuana cuenta con instalaciones modernas, espacios diseñados para el aprendizaje colaborativo enfocado en la excelencia académica.'" :img="'/pagesImages/una-mirada-Tijuana.webp'" :alt="'Campus Magno Tijuana'" class="mb-16" />
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Instalaciones</h2>
            <p class="text-center mb-8">Ubicado en una zona estratégica con excelente conectividad, Campus Magno Tijuana brinda espacios diseñados<br class="lg:block hidden"> para fomentar la reflexión, la creatividad y el intercambio de ideas.</p>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center mb-16">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Instalaciones especializadas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Áreas equipadas para disciplinas como Psicología y Derecho, con herramientas especializadas para el desarrollo práctico de los estudiantes.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas verdes y deportivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Canchas y zonas recreativas que promueven un estilo de vida saludable, integrando deporte y bienestar en la rutina estudiantil.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Biblioteca y recursos digitales</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Con acceso a libros físicos, bases de datos digitales y computadoras, la biblioteca fomenta el estudio en un entorno cómodo y bien equipado.</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images[currentImage]"
                        alt="Instalaciones de Campus Magno Tijuana"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-between">
                <div class="flex lg:flex-row flex-col items-center justify-center">
                    <div class="flex lg:order-1 order-2 items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images2[currentImage2]"
                        alt="Instalaciones de Campus Magno Tijuana"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage2"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                    <div class="lg:w-[50%] order-1 lg:order-2 text-justify mb-8 lg:mb-0 lg:ml-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Auditorio</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">En este espacio se realizan eventos culturales, conferencias, encuentros multidisciplinarios, foros, debates y presentaciones.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Cafetería</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Despierta es un concepto de cafeterías que fusiona una alimentación saludable con el sabor casero de una comida nutritiva.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="grid lg:grid-cols-2 grid-cols-1 gap-10">
                
            </div> -->
        </div>
    </div>
    <h2 class="text-hgold text-center font-serif md:text-[42px] text-[32px] lg:px-0 px-8 lg:mb-4 leading-none w-full">Oferta académica en Campus Magno Tijuana</h2>
    <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho'],
        Maestrías: [ 'Derecho Fiscal', 'Educación', 'Mercadotecnia', 'Psicoterapia con un<br> enfoque Psicoanalítico'],
        Doctorados: ['Alta Dirección', 'Derecho', 'Educación']
    }" class="flex items-center justify-center" />
    <!-- <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho'],
        Maestrías: ['Alta Dirección', 'Derecho Corporativo', 'Derecho Fiscal', 'Derecho Penal', 'Contabilidad', 'Educación', 'Mercadotecnia Digital', 'Psicoterapia con un<br> enfoque Psicoanalítico'],
        Doctorados: ['Alta Dirección', 'Derecho', 'Educación']
    }" class="flex items-center justify-center" /> -->
    <section class="flex w-full items-center justify-center my-10">
        <div class="lg:flex w-full max-w-[1200px] justify-center items-center mb-6">
            <div class="flex flex-col md:pr-14 pb-7 md:pb-0 w-full md:w-1/2 items-center md:items-end lg:px-16 px-8">
                <li class="list-none flex flex-col items-center md:items-start">
                    <h3 class="text-center md:text-left line-height-36 text-3xl md:text-4xl text-hgold mb-4 font-serif">Diplomados</h3>
                    <ul class="text-left pl-6 list-disc space-y-1 mb-4">
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Tanatología</a>
                        </li>
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Criminología</a>
                        </li>
                    </ul>
                </li>
            </div>
            <div class="flex w-full md:w-1/2 justify-center md:justify-start lg:px-0 px-8">
                <img src="/pagesImages/square-docs.webp" width="494" height="494" loading="lazy" class="w-auto h-auto" alt="Explora los Diplomados">
            </div>
        </div>
    </section>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">Nuestros modelos educativos</h2>
            <section class="flex items-center justify-center mb-16 w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo ejecutivo</span>
                                </h3>
                                <p class="lg:hyphens-none hyphens-auto">
                                    Está diseñado para brindar flexibilidad sin comprometer la calidad académica. Los programas se estructuran en bloques trimestrales, cada uno fusionando tres materias, impartidas por especialistas. Requiere autodisciplina, gestión eficiente del tiempo y compromiso con el éxito académico.
                                </p>
                            </div>
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp" alt="Modelo ejecutivo en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/modelo-escolarizado-madin.webp" alt="Estudiante modelo escolarizado en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                                <h3>
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo escolarizado</span>
                                </h3>
                                <p class="lg:hyphens-none hyphens-auto">
                                    Ofrece una formación académica de calidad con un enfoque práctico y humano. Cada licenciatura está diseñada con objetividad e integrada con talleres y seminarios, que potencian la preparación para enfrentar los desafíos del mundo actual con conocimiento, habilidades y experiencia.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Tour virtual</h2>
            <p class="mb-10">Conoce el Campus Magno Tijuana en nuestro tour virtual.</p>
            <Tour360 :src="'https://tourmkr.com/F1AHGGFK8P'"  class="w-full mb-12"/>
            
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-10 leading-none w-full">Galería</h2>
            <!-- <Tour360 :src="'https://www.google.com/maps/embed?pb=!4v1783534363477!6m8!1m7!1sCAoSHENJQUJJaENvSDJQbDBNME5lRXd4RzNjNEVtSEw.!2m2!1d32.50127219114792!2d-116.9362063087836!3f59.88746!4f0.11253999999999564!5f0.7820865974627469'"  class="w-full"/> -->
            <Instalaciones :items="tour" class="" />
            <!-- <iframe width="1140" height="641" src="https://www.youtube.com/embed/qBOIBjsj3RE" title="Campus Presa Madín" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
        </div>
    </div>
	<Ubicacion :campus="'Campus Magno Tijuana'" :mapa="'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6729.859852769105!2d-116.935624!3d32.501302!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d938899951ca8b%3A0x7d5635d445fb8e45!2sUniversidad%20Humanitas%20Campus%20Tijuana!5e0!3m2!1ses-419!2sus!4v1738216171228!5m2!1ses-419!2sus'" :testo1="'El Campus está ubicado en una zona estratégica en Tijuana, Baja California. Para arribar en transporte público, se deben de considerar las siguientes rutas: Centro - Insurgentes - Lago, 5 y 10 - Insurgentes - Lago, Blvd 200 - Insurgentes - Lago y Rosarito - 5 y 10 - Insurgentes - Lago. La principal vía de acceso es: Insurgentes.'" :ubicacion="'Paseo del Cucapah 16301, Fraccionamiento Lago Sur, Delegación Cerro Colorado, Tijuana C.P. 22210, Baja California.'" :telefono="'664-634-3864'" class="lg:px-0 px-8" />
</template>

<style scoped>
</style>
